module.exports = __webpack_public_path__ + "static/media/iconCoin.83f3f1cf.svg";